/**
 * O que a tela de cadastro da SENATRAN calcula sem servidor (ADR-035). As regras de forma
 * são do domínio, no servidor; aqui só a soma e a leitura do que foi colado.
 */
import type { CadastroDaConcessao } from "../api/tipos";

export const MEIOS: Record<number, string> = {
  1: "Físico",
  2: "Digital",
  3: "Avulso",
  4: "Vale-pedágio obrigatório",
};

export const TIPOS: Record<number, string> = { 1: "Automático", 2: "Avulso" };

/** Quantas pendências a concessão tem, somando pórticos e operadores **ativos**. */
export function totalDePendencias(c: CadastroDaConcessao): number {
  return (
    c.pendencias.length +
    c.porticos
      .filter((p) => p.ativo)
      .reduce((n, p) => n + p.pendencias.length, 0) +
    c.operadores
      .filter((o) => o.ativo)
      .reduce((n, o) => n + o.pendencias.length, 0)
  );
}

/** Os ids colados — um por linha, separados por vírgula ou no meio de texto —, sem repetir. */
export function lerIds(texto: string): string[] {
  const achados = texto.match(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
  );
  return [...new Set((achados ?? []).map((i) => i.toLowerCase()))];
}
